import React, { Children } from 'react'
import { useStore } from "react-redux";
import { Modal } from '../../_helpers/Modal';
import { Oval } from "react-loader-spinner";
import { useNavigate } from 'react-router-dom';
// import RegisterUser from '../../_actions/RegisterAction';
const LandingPageDesign = ({ children }: any) => {
    const navigate = useNavigate();
    const store = useStore<any>().getState();

    return (
        <>
            <Modal show={store.loader.load}>
                <div className="loader">
                    <Oval
                        height={200}
                        width={200}
                        color="#122d59"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#122d59"
                        strokeWidth={3}
                        strokeWidthSecondary={3}
                    /></div>
            </Modal>
            <div className='comntainer-fluid m-0'>
                <div className='row full_height bg_newblue m-0 position-relative'>
                    <div className='col-lg-9 col-md-12 bg-white login_border'>

                        <div className="mt-3">
                            <div className="text-start">
                                <button type='button' className='border-0 bg-body'>
                                    <img src={require('../../assets/img/ETM-logo1.png')} alt="" width="100px" onClick={() => navigate("/")} />
                                </button>
                            </div>
                        </div>

                        <div className='content_landing d-flex justify-content-center align-items-center'>
                            <div className="col-xl-4 col-lg-5 col-md-8 col-sm-6 col-12">
                                <div className="card bg-transparent border-0 rounded-lg">
                                    {children}
                                </div>
                            </div>
                        </div>
                        {/* <div className=' m-2 login_logo'>
                            <div className='h-100 d-flex p-auto'>
                                <img className='d-flex m-auto' src='/assets/img/ETM-logo1.png' alt='ETM-logo' width="150px" height="100px"></img>
                            </div>
                        </div> */}
                    </div>
                </div>

            </div>

        </>
    )
}
export default LandingPageDesign